export enum SettingsOptions {
	LINK = "link",
	GROUPING = "enable-grouping",
	FILTERING = "value-filtering",
	CLICK_TRIGGER = "one-click-trigger",
	MASTER_DETAIL = "ticker-master-detail",
	CHART_ON_HOVER = "chart-on-hover",
	DENSE_MODE = "dense-mode",
	PANEL_MODE = "panel-mode",
	DOWNLOAD_CSV = "download-csv",
}

export type ViewId =
	| "Elements"
	| "Chart"
	| "Screener"
	| "Earnings Analysis"
	| "Monitor"
	| "News"
	| "Holders"
	| "Chat"
	| "Backtest"
	| "Financials"
	| "Markets"
	| "Navigation"
	| "Quote"
	| "Advanced Quote"
	| "Drift Forecast"
	| "Dark Short"
	| "Holdings"
	| "Insiders";

export interface User {
	email: string;
}

export type AuthColor = "bronze" | "silver" | "gold" | "platinum";

export enum LocalStorageKeys {
	redirectPath = "redirectPath",
	attemptToBuy = "attemptToBuy",
	attemptToConfirmPhone = "attemptToConfirmPhone",
	lastAttemptToConfirmPhoneDate = "lastAttemptToConfirmPhoneDate",
	user = "user",
	phoneConfirm = "phoneConfirm",
}
